import {action, observable, ObservableSet} from 'mobx'

export default class ConditionsContext {
    /** @type {ObservableSet<{type: string, if_value: string, then_value: number}>} */
    @observable conditions

    constructor(conditions) {
        this.conditions = new ObservableSet()
        if (conditions) {
            for (const condition of conditions) {
                this.conditions.add({
	                  id: condition.id,
	                  campaign_id: condition.campaign_id,
                    type: condition.type,
                    if_value: condition.if_value,
                    then_value: condition.then_value
                })
            }
        }
        this.check()
    }

    get conditionsArray() {
        const conditions = []
        this.conditions.forEach((value => {
            conditions.push({...value})
        }))
        return conditions
    }

    @action
    addConditions(campaign_id = '1') {
        this.conditions.add({
	          campaign_id,
            type: "=",
            if_value: 0,
            then_value: 0
        })
    }

    @action
    delCondition(condition) {
        this.conditions.delete(condition)
        this.check()
    }

    @action
    check() {
        if (this.conditions.size === 0) {
            this.addConditions()
        }
    }

    @action
    async saveSettings() {
        console.log('save')
        return false
    }

    @action toJSON() {
        return this.conditions
    }
}